import { swRequest } from "./sw-request";

export const deleteCall = (body) =>
  swRequest({
    path: "/api/calls/delete",
    method: "POST",
    body,
  });

export const getCall = ({ callId }) =>
  swRequest({
    path: "/api/calls/get",
    method: "GET",
    params: { callId },
  });

export const modifyCall = (body) =>
  swRequest({
    path: "/api/calls/modify",
    method: "POST",
    body,
  });

export const queryCalls = (body, opts = {}) =>
  swRequest(
    {
      path: `/api/calls/query`,
      method: "POST",
      body,
    },
    opts,
  );
